import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import {
	Button,
	ButtonSize,
	ButtonVariant,
	ProductIcon,
	ProductIconType,
} from 'cond-ui-kit';

import useNavigation from '~/hooks/useNavigation';



const messages = defineMessages({
	button: {
		id: 'ui.bookWebinar.button',
	},
});



const TUTORIALS_DEEPLINK = '/courses/7a69d590-25bf-4c60-923c-ce47f0e80e50';

const BookWebinarButton: React.FC = () => {
	const navigation = useNavigation();

	return (
		<Button
			iconLeft={(
				<ProductIcon
					size={16}
					type={ProductIconType.VideoCamera}
				/>
			)}
			onClick={() => navigation.navigate({
				routeName: 'community',
				routeParams: { ms_url: TUTORIALS_DEEPLINK },
			})}
			size={ButtonSize.Small}
			variant={ButtonVariant.CallToAction}
		>
			<FormattedMessage {...messages.button} />
		</Button>
	);
};



export default BookWebinarButton;
